import { YMMetricHelper } from '@beef/metric';

import { getTextFromHtml } from 'utils/format-string';
import { getCommonPropsStore2024 } from 'utils/analytics/ymBase';

export class CommonMetric extends YMMetricHelper {
  protected readonly MAIN_PAGE_PARAMS_KEY = 'main';

  protected readonly MAIN_BANNERS_PARAMS_KEY = 'main_banners_ev_';

  protected setMainPageParams = (params: Record<string, any>) => {
    if (typeof window === 'undefined')
      return {
        [this.MAIN_PAGE_PARAMS_KEY]: {
          ...params,
        },
      };

    const commonPropsYM = getCommonPropsStore2024();

    return {
      [this.MAIN_PAGE_PARAMS_KEY]: {
        ...commonPropsYM,
        ...params,
      },
    };
  };

  protected setMainBannerParams = (params: Record<string, any>) => {
    if (typeof window === 'undefined')
      return {
        [this.MAIN_BANNERS_PARAMS_KEY]: {
          ...params,
        },
      };

    const commonPropsYM = getCommonPropsStore2024();

    return {
      [this.MAIN_BANNERS_PARAMS_KEY]: {
        ...commonPropsYM,
        ...params,
      },
    };
  };

  handleMainPageView() {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'view',
        item_type: 'page',
      }),
    );
  }

  handleNotSupport() {
    return null;
  }

  handleBlockView(block_title: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'view',
        item_type: 'section',
        section_name: getTextFromHtml(block_title),
      }),
    );
  }

  handleBeelineTVIconClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'icon',
        icon_name: data,
        object_type: 'block',
        block_name: 'скачать приложение билайн тв',
        section_name: 'для дома',
      }),
    );
  }

  handleIconClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'icon',
        icon_name: getTextFromHtml(parsedData.iconName),
        object_type: 'block',
        section_name: 'мобильное приложение',
      }),
    );
  }

  handleBannerView(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'view',
        item_type: 'block',
        section_name: data,
        block_name: 'переход в ИМ',
      }),
    );
  }

  handleDeviceBlockClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'block',
        section_name: data,
        block_name: 'переход в ИМ',
      }),
    );
  }

  handleBannerButtonClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        section_name: getTextFromHtml(parsedData.blockTitle),
        block_text: getTextFromHtml(parsedData.buttonText),
      }),
    );
  }

  handleCardClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'element',
        block_name: 'вакансии для экспертов',
        element_title: getTextFromHtml(parsedData.elementTitle),
        object_type: 'block',
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleServiceClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'element',
        block_name: 'также к вашим услугам',
        element_title: getTextFromHtml(parsedData.elementTitle),
        object_type: 'block',
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleCardBlockClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'element',
        object_type: 'block',
        element_title: getTextFromHtml(parsedData.elementTitle),
        block_name: 'преимущества и услуги',
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleBlockNavClick(link_text: string, block_title: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'link',
        link_text: getTextFromHtml(link_text),
        object_type: 'block',
        block_name: 'быстрые ссылки',
        section_name: getTextFromHtml(block_title),
      }),
    );
  }

  handleSquareCardClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'element',
        element_title: getTextFromHtml(parsedData.title),
        object_type: 'block',
        block_name: parsedData.block_name,
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleEthernetChipsClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'tab',
        tab_text: getTextFromHtml(parsedData.buttonText),
        object_type: 'block',
        section_name: 'для дома',
        block_name: 'домашний интернет',
      }),
    );
  }

  handleButtonClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        button_text: getTextFromHtml(parsedData.buttonText),
        object_type: 'block',
        block_name: 'перейти в билайн',
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleCareerNavClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        button_text: 'все вакансии',
        object_type: 'block',
        block_name: data,
        section_name: 'карьера',
      }),
    );
  }

  handleHRBlockShowMoreClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        button_text: parsedData.buttonText,
        object_type: 'block',
        block_name: parsedData.blockName,
        section_name: 'карьера',
      }),
    );
  }

  handleBeelineTvButtonClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        button_text: data,
        object_type: 'block',
        block_name: 'билайн тв',
        section_name: 'для дома',
      }),
    );
  }

  handleEthernetButtonClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        button_text: data,
        object_type: 'block',
        block_name: 'домашний интернет',
        section_name: 'для дома',
      }),
    );
  }

  handleEthernetBlockClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'card',
        card_title: data,
        object_type: 'block',
        block_name: 'домашний интернет',
        section_name: 'для дома',
      }),
    );
  }

  handleMnpButtonClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        button_text: getTextFromHtml(parsedData.buttonText),
        object_type: 'block',
        block_name: 'уже в билайне',
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleMnpClick(data: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'block',
        block_name: 'перейти в билайн',
        section_name: data,
      }),
    );
  }

  handleTabClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'tab',
        tab_text: getTextFromHtml(parsedData.tabText),
        object_type: 'block',
        block_name: 'сервисы',
        section_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleTabCardClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'element',
        element_title: getTextFromHtml(parsedData.elementTitle),
        tab_name: getTextFromHtml(parsedData.tabName),
        object_type: 'block',
        block_name: 'сервисы',
        service_name: getTextFromHtml(parsedData.blockTitle),
      }),
    );
  }

  handleTabBarClick(tab_text: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'tab',
        section_name: 'tabbar',
        tab_text: getTextFromHtml(tab_text),
      }),
    );
  }

  handleTabBarButtonClick() {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'button',
        section_name: 'tabbar',
        button_name: 'navigation_menu',
      }),
    );
  }

  handleTabBarMenuClick(element_title: string) {
    this.sendParamsEvent(
      this.setMainPageParams({
        action: 'click',
        item_type: 'element',
        section_name: 'tabbar',
        element_title: getTextFromHtml(element_title),
      }),
    );
  }

  handleTopBannerView(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainBannerParams({
        action: 'view',
        item_type: 'banner',
        banner_title: getTextFromHtml(parsedData.bannerTitle),
        banner_description: getTextFromHtml(parsedData.bannerDescription),
        banner_url: getTextFromHtml(parsedData.bannerUrl),
        banner_id: `${parsedData.bannerId}`,
        banner_type: 'slider',
        banner_position: `${parsedData.bannerPosition}`,
        object_type: 'block',
        block_name: 'main_top',
      }),
    );
  }

  handleTopBannerClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainBannerParams({
        action: 'click',
        item_type: 'banner',
        banner_title: getTextFromHtml(parsedData.bannerTitle),
        banner_description: getTextFromHtml(parsedData.bannerDescription),
        banner_url: getTextFromHtml(parsedData.bannerUrl),
        banner_id: `${parsedData.bannerId}`,
        banner_type: 'slider',
        banner_position: `${parsedData.bannerPosition}`,
        object_type: 'block',
        block_name: 'main_top',
      }),
    );
  }

  handleTopBannerButton(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainBannerParams({
        action: 'click',
        item_type: 'button',
        banner_title: getTextFromHtml(parsedData.bannerTitle),
        banner_description: getTextFromHtml(parsedData.bannerDescription),
        banner_url: getTextFromHtml(parsedData.bannerUrl),
        banner_id: `${parsedData.bannerId}`,
        banner_type: 'slider',
        banner_position: `${parsedData.bannerPosition}`,
        object_type: 'banner',
        block_name: 'main_top',
        button_text: `${parsedData.buttonText}`,
      }),
    );
  }

  handleInlineBannerView(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainBannerParams({
        action: 'view',
        item_type: 'banner',
        banner_title: getTextFromHtml(parsedData.bannerTitle),
        banner_description: getTextFromHtml(parsedData.bannerDescription),
        banner_url: getTextFromHtml(parsedData.bannerUrl),
        banner_id: `${parsedData.bannerId}`,
        banner_position: `${parsedData.bannerPosition}`,
        object_type: 'block',
        banner_type: 'slider',
        block_title: `${parsedData.blockTitle}`,
      }),
    );
  }

  handleInlineBannerClick(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainBannerParams({
        action: 'click',
        item_type: 'banner',
        banner_title: getTextFromHtml(parsedData.bannerTitle),
        banner_description: getTextFromHtml(parsedData.bannerDescription),
        banner_url: getTextFromHtml(parsedData.bannerUrl),
        banner_id: `${parsedData.bannerId}`,
        banner_position: `${parsedData.bannerPosition}`,
        object_type: 'block',
        banner_type: 'slider',
        block_title: `${parsedData.blockTitle}`,
      }),
    );
  }

  handleInlineBannerButton(data: string) {
    const parsedData = JSON.parse(data);
    this.sendParamsEvent(
      this.setMainBannerParams({
        action: 'click',
        item_type: 'button',
        banner_title: getTextFromHtml(parsedData.bannerTitle),
        banner_url: getTextFromHtml(parsedData.bannerUrl),
        banner_description: getTextFromHtml(parsedData.bannerDescription),
        banner_id: `${parsedData.bannerId}`,
        banner_position: `${parsedData.bannerPosition}`,
        object_type: 'banner',
        banner_type: 'slider',
        block_title: `${parsedData.blockTitle}`,
        button_text: `${parsedData.buttonText}`,
      }),
    );
  }
}

export const commonMetric = new CommonMetric({
  counterId: 26001372,
  isEcommerce: false,
  debug: true,
});
